function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "4.5179mm",
    height: "4.2968mm",
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M25 15c0,0 0,0 0,0 0,0 0,0 0,0 0,0 -1,0 -1,0 0,0 0,0 0,0l0 0c-5,0 -7,4 -9,8 -1,2 -3,3 -5,4 -4,3 -5,11 -2,14 4,4 12,0 17,0 5,0 12,4 16,0 3,-3 2,-11 -2,-14 -2,-1 -4,-2 -5,-4 -2,-4 -4,-8 -9,-8l0 0zm24 2c0,-4 -2,-7 -6,-7 -3,0 -5,3 -5,7 0,4 2,8 5,8 4,0 6,-4 6,-8zm-11 -10c0,-4 -3,-7 -6,-7 -3,0 -6,3 -6,7 0,4 3,8 6,8 3,0 6,-4 6,-8zm-15 0c0,-4 -3,-7 -6,-7 -3,0 -6,3 -6,7 0,4 3,8 6,8 3,0 6,-4 6,-8zm-12 10c0,-4 -2,-7 -5,-7 -3,0 -6,3 -6,7 0,4 3,8 6,8 3,0 5,-4 5,-8z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaw);
export default __webpack_public_path__ + "static/media/paw.9cf7c6918545324383ee137ea49cd4dd.svg";
export { ForwardRef as ReactComponent };